import React from "react";
import LearningWheel from "./components/LearningWheel";

const App = () => {
  return (
    <div className="flex h-[100vh]">
      <LearningWheel />
    </div>
  );
};

export default App;
